import { MapObject } from '../../types/general';

export const pushUnique = (targetArray: any[], possibleNewItems: any[]): any[] => {
    return possibleNewItems
        .reduce(
            (accumulator, item: any) => {
                if (!accumulator.includes(item)) {
                    accumulator.push(item);
                }
                return accumulator;
            },
            [...targetArray],
        );
};

export const includesAll = (targetArray: any[], possiblyIncluded: any[]): boolean => {
    return possiblyIncluded.every((property) => targetArray.includes(property));
};

export const shuffle = (arr: any[]): any[] => {
    const clone = [...arr];
    let j;
    let x;
    let i;
    for (i = clone.length - 1; i > 0; i -= 1) {
        j = Math.floor(Math.random() * (i + 1));
        x = clone[i];
        clone[i] = clone[j];
        clone[j] = x;
    }
    return clone;
};

export const shallowEquals = (arrA: any[], arrB: any[]): boolean => {
    if (arrA === arrB) {
        return true;
    }

    if (arrB.length !== arrA.length) {
        return false;
    }

    for (let i = 0; i < arrA.length; i += 1) {
        if (arrA[i] !== arrB[i]) {
            return false;
        }
    }

    return true;
};

export const insertItemIntoArray = (array: any, item: any): any[] => {
    const newArray = array.slice();
    if (!Array.isArray(item)) {
        if (newArray.indexOf(item) === -1) {
            newArray.splice(-1, 0, item);
        }
    } else {
        item.forEach((el: any) => {
            if (newArray.indexOf(el) === -1) {
                newArray.splice(-1, 0, el);
            }
        });
    }

    return newArray;
};

export const insertOrRemoveItemsInArray = (array: (number | string)[], items: (number | string)[]) => {
    const arrClone = [...array];
    items.forEach((item) => {
        const index = array.indexOf(item);
        if (index === -1) {
            arrClone.push(item);
        } else {
            arrClone.splice(index, 1);
        }
    });

    return arrClone;
};

export const removeItemFromArray = (array: any, item: any): any[] => {
    const newArray = array.slice();
    const itemIndex = newArray.indexOf(item);
    if (itemIndex !== -1) {
        newArray.splice(itemIndex, 1);
    }

    return newArray;
};

export const ensureReturnArray = (value: MapObject | MapObject[] | null | undefined): MapObject[] => {
    if (Array.isArray(value)) {
        return value;
    }
    if (value) {
        return [value];
    }
    return [];
};

const arrayUtil = {
    includesAll,
    pushUnique,
    shallowEquals,
    shuffle,
    insertItemIntoArray,
    removeItemFromArray,
    ensureReturnArray,
};

export default arrayUtil;
